// GPU display names ("NVIDIA RTX 4090 · 24 GB") for what runs asked for or ran on, from the org's offerings.
import { useKList } from "@nodus/api";
import { gpuName, type OfferingLike } from "@nodus/ui";
import * as React from "react";

/** Names a GPU type, id, slug or offering as the API names it; unknown names come back unchanged. */
export type GpuNamer = (token: string) => string;

export const catalogGpuName: GpuNamer = (t) => gpuName(t, []);

export function useGpuNames(org: string): GpuNamer {
  const offerings = useKList("Offering", { org }, { watch: false });
  const items = offerings.data?.items as OfferingLike[] | undefined;
  return React.useCallback((t: string) => gpuName(t, items ?? []), [items]);
}
